<div class="nav-card">
  <div class="nav-card-icon">
    <app-icon [name]="icon()!"></app-icon>
  </div>
  <div class="nav-card-title">
    <div class="nav-card-title-header">{{ label() }}</div>
  </div>
</div>
